import {api,apitest} from '../api.request';
//供应链数据分析看板

//当前业务数据（安款）
const get1=function(o){
   return api.get("/supply/get1",o)
} 
//成衣未准交款
const get2=function(o){
   return api.get("/supply/get2",o)
} 
//首单批次准交率
const get3=function(o){
    return api.get("/supply/get3",o)
 } 
//当前业务数据（按款）
const getCurrentBusinessData=function(o){
   return apitest.get("/supply/currentBusinessData",o)
}
//首单批次准交率 
const getDeliveryRateOfTheFirstBatch=function(o){
   return apitest.get("/supply/deliveryRateOfTheFirstBatch",o)
}
//中间模块
const getIntermediateModule=function(o){
   return apitest.get("/supply/intermediateModule",o)
}
//成衣未准交款
const getPaymentNotAllowedForReadyToWear=function(o){
   return apitest.get("/supply/paymentNotAllowedForReadyToWear",o)
}
//中间模块（类型）下拉框  BTW:这个其实是生产部门
const getTypeData=function(o){
   return apitest.get("/supply/typeData",o)
}
export default {
   get1,
   get2,
   get3,
   getCurrentBusinessData,
   getDeliveryRateOfTheFirstBatch,
   getIntermediateModule,
   getTypeData,
   getPaymentNotAllowedForReadyToWear
}

